// 📁 src/pages/OutgoingTransfersPage.jsx
import { useEffect, useState } from "react";
import { Table } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../styles/TableStyles.css";
import { PackageCheck, XCircle, CheckCircle2 } from "lucide-react";

export default function OutgoingTransfersPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const getUser = async () => {
    try {
      const res = await fetch("/api/protected/me", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const json = await res.json();
      return {
        pharmacyCode: json?.user?.pharmacyCode?.replace(/^0+/, ""),
        firma: json?.user?.firma,
      };
    } catch (e) {
      console.error("Chyba při načítání uživatele:", e);
      return null;
    }
  };

  const fetchData = async (firma, pharmacyCode) => {
    try {
      const res = await fetch(`/api/transfers/outgoing/${firma}/${pharmacyCode}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const json = await res.json();
      setData(json);
    } catch (e) {
      console.error("Chyba načítání outgoing:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      const u = await getUser();
      setUser(u);
      if (u) fetchData(u.firma, u.pharmacyCode);
    })();
  }, []);

  const markPicked = async (id) => {
    if (!user) return;
    try {
      await fetch(`/api/transfers/markPicked/${user.firma}/${user.pharmacyCode}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ id }),
      });
      fetchData(user.firma, user.pharmacyCode);
    } catch (e) {
      console.error("Chyba označení vychystání:", e);
    }
  };

  const markRejected = async (id) => {
    if (!user) return;
    try {
      await fetch(`/api/transfers/markRejected/${user.firma}/${user.pharmacyCode}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ id }),
      });
      fetchData(user.firma, user.pharmacyCode);
    } catch (e) {
      console.error("Chyba označení nedodáno:", e);
    }
  };

  const markPickedAll = async () => {
    if (!user) return;
    const ids = data.filter((row) => row.stav === "potvrzeno").map((r) => r._id);
    if (!ids.length) return;
    try {
      await Promise.all(
        ids.map((id) =>
          fetch(`/api/transfers/markPicked/${user.firma}/${user.pharmacyCode}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({ id }),
          })
        )
      );
      fetchData(user.firma, user.pharmacyCode);
    } catch (e) {
      console.error("Chyba označení vše jako vychystáno:", e);
    }
  };

  if (loading) return <p>Načítám…</p>;

  return (
    <div className="page">
      <h1>Převodky – Výdej</h1>
      <Table className="styled-table">
        <thead>
          <tr>
            <th>PDK</th>
            <th style={{ width: "25%" }}>Název</th>
            <th>Expirace</th>
            <th>Šarže</th>
            <th>Množství</th>
            <th>Cílová pobočka</th>
            <th style={{ width: "160px" }}>Akce</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row._id}>
              <td>{row.PDK}</td>
              <td>{row.Název}</td>
              <td>{new Date(row.Exspirace).toLocaleDateString()}</td>
              <td>{row.Šarže}</td>
              <td>{row.Množství}</td>
              <td>{row.targetPharmacyCode}</td>
              <td>
                {row.stav === "potvrzeno" && (
                  <>
                    <button
                      onClick={() => markPicked(row._id)}
                      style={{
                        padding: "2px 6px",
                        fontSize: "12px",
                        background: "#28a745",
                        border: "none",
                        color: "white",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "4px",
                      }}
                    >
                      <PackageCheck size={14} style={{ marginRight: "4px" }} />
                      Označit vychystáno
                    </button>
                    <button
                      onClick={() => markRejected(row._id)}
                      style={{
                        padding: "2px 6px",
                        fontSize: "12px",
                        background: "#dc3545",
                        border: "none",
                        color: "white",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <XCircle size={14} style={{ marginRight: "4px" }} />
                      Odmítnout
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {data.some((row) => row.stav === "potvrzeno") && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
          <button
            onClick={markPickedAll}
            style={{
              backgroundColor: "green",
              color: "white",
              fontSize: "16px",
              padding: "6px 12px",
              border: "none",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircle2 size={18} style={{ marginRight: "6px" }} />
            Označit vše jako vychystáno
          </button>
        </div>
      )}
    </div>
  );
}
